import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const CREATE_OFFER_REVISION_MUTATION = gql`
mutation createOfferRevision($documentVersion: DocumentVersionInput!) {
  quotes {
    createRevision(documentVersion: $documentVersion) {
      title
      documentId
      latestRevision
    }
  }
}
`;

@Injectable({
  providedIn: 'root'
})
export class CreateOfferRevisionMutation extends Mutation<RootMutation> {
  document = CREATE_OFFER_REVISION_MUTATION;
}
